import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { ClerkProvider } from '@clerk/react'
import { router } from './App'
import { clerkConfigurationError, stagingRedirectUrl } from './lib/clerk-config'
import { initPostHog } from './lib/posthog'
import './index.css'

const stagingRedirect = stagingRedirectUrl(new URL(window.location.href))
const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
const authConfigurationError = clerkConfigurationError(new URL(window.location.href), publishableKey)

if (stagingRedirect) {
  window.location.replace(stagingRedirect)
} else if (authConfigurationError) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <div className="grid min-h-screen place-items-center bg-page p-6 text-center">
      <div>
        <p className="font-medium text-ink-900">Could not start Hey Tasky.</p>
        <p className="mt-1 text-sm text-ink-500">{authConfigurationError}</p>
      </div>
    </div>,
  )
} else {
  initPostHog()

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={publishableKey}
        afterSignOutUrl="/"
      >
        <RouterProvider router={router} />
      </ClerkProvider>
    </React.StrictMode>,
  )
}
